import stockAPI from "@/utility/api.js";

const state = {
  newsAll: {},
  newsOwner: {},
  oneNews: {},
  pagination: {}
};

const getters = {
  newsAllList(state) {
    const initData = [
      {
        id: 1,
        title: "2330 新聞標題",
        released_at: "2020-08-29",
        user: {
          id: 2,
          name: "sojtest"
        }
      }
    ];
    if (!state.newsAll.data) {
      return initData;
    } else {
      return state.newsAll.data;
    }
  },
  newsOwnerList(state) {
    const initData = [
      {
        id: 1,
        title: "2330 新聞標題",
        released_at: "2020-08-29",
        user: {
          id: 2,
          name: "sojtest"
        }
      }
    ];
    if (!state.newsOwner.data) {
      return initData;
    } else {
      return state.newsOwner.data;
    }
  },
  oneNews(state) {
    const initData = {
      id: 1,
      title: "2330 新聞標題",
      released_at: "2020-08-29",
      content: "2330 新聞內容",
      user: {
        id: 2,
        name: "sojtest",
        is_news_owner: false
      },
      files: [],
      is_admin: false
    };
    if (!state.oneNews.id) {
      return initData;
    } else {
      return state.oneNews;
    }
  },
  paginationInNewsOwner(state) {
    //remove data key in paginationData
    // eslint-disable-next-line no-unused-vars
    const { data, ...paginationData } = state.newsOwner;
    return paginationData;
  },
  paginationInNewsAll(state) {
    //remove data key in paginationData
    // eslint-disable-next-line no-unused-vars
    const { data, ...paginationData } = state.newsAll;
    return paginationData;
  }
};

const mutations = {
  newsAll(state, res) {
    state.newsAll = { ...res };
  },
  newsOwner(state, res) {
    state.newsOwner = { ...res };
  },
  oneNews(state, res) {
    state.oneNews = { ...res };
  },
  oneNewsTitle(state, res) {
    state.oneNews.title = res;
  },
  oneNewsReleasedAt(state, res) {
    state.oneNews.released_at = res;
  },
  oneNewsContent(state, res) {
    state.oneNews.content = res;
  }
};
const actions = {
  async fetchNewsAll({ getters, commit }, page) {
    const stockId = getters.outputOfStockSymbol;
    const res = await stockAPI.GET(`api/stock/${stockId}/news?page=${page}`);
    if (res) {
      commit("newsAll", res);
      return Promise.resolve();
    }
  },
  async fetchOneNews({ commit }, newsId) {
    const res = await stockAPI.GET(`api/news/${newsId}`);
    if (res) {
      commit("oneNews", res);
      return Promise.resolve();
    }
  },
  async fetchNewsOwner({ getters, commit }, page) {
    const stockId = getters.outputOfStockSymbol;
    const res = await stockAPI.GET(
      `api/stock/${stockId}/user/news?page=${page}`
    );
    if (res) {
      commit("newsOwner", res);
      return Promise.resolve();
    }
  },
  createOneNews({ getters }, formData) {
    const stockId = getters.outputOfStockSymbol;
    return stockAPI.POST(`api/stock/${stockId}/news`, formData);
  },
  // eslint-disable-next-line no-unused-vars
  updateOneNews({ getters }, formData) {
    const stockId = getters.outputOfStockSymbol;
    const oneNewsId = getters.oneNews.id;
    return stockAPI.POST(`api/stock/${stockId}/news/${oneNewsId}`, formData);
  },
  // eslint-disable-next-line no-unused-vars
  deleteOneNews({ state }, selectedList) {
    return stockAPI.DELETE(`api/news`, selectedList);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
